import React from "react"
import {HamburgerButton} from './Hamburger.styles'
import HamburgerIcon from '../../images/menu-hamburger.svg'
import closeBtn from "../../images/close-btn.svg";


const Hamburger = ({ menuOpen, handleOverlayMenu }) => {

    const getIcon = ()=> {
        return menuOpen ? closeBtn : HamburgerIcon;
    }

    return(
        <HamburgerButton onClick={handleOverlayMenu}>
            <img src={getIcon()} alt="Hamburger menu"></img>
        </HamburgerButton>
    )
}

export default Hamburger;